<div class="selector-container">
    <!-- Min field -->
    <mat-form-field>
        @if (opts.showCurrencyChar) {
            <span matPrefix class="field-prefix-char">
                {{ currencyChar }} &nbsp;
            </span>
        }
        <input
            matInput
            type="text"
            placeholder="Min"
            name="min-input"
            (input)="transform($event)"
            [formControl]="minControl"
        />
            @if (opts.showCurrencyCode) {
            <span matSuffix class="field-suffix-code">
                {{ currencyCode }}
            </span>
        } @if (opts.showClearButton && (minControl.value || minControl.value ===
        0)) {
            <button
                matSuffix
                mat-icon-button
                aria-label="Clear"
                class="field-suffix-clear"
                [class.abs-pos-clear-button]="opts.absPosClearButton"
                (click)="clearMin(opts.applyOnClear)"
            >
                <fa-icon [icon]="['far', 'times-circle']"></fa-icon>
            </button>
        }
    </mat-form-field>

    <!-- Max field-->
    <mat-form-field>
        @if (opts.showCurrencyChar) {
            <span matPrefix class="field-prefix-char">
                {{ currencyChar }} &nbsp;
            </span>
            }
            <input
                matInput
                type="text"
                placeholder="Max"
                name="max-input"
                (input)="transform($event)"
                [formControl]="maxControl"
            />
        @if (opts.showCurrencyCode) {
            <span matSuffix class="field-suffix-code">
                {{ currencyCode }}
            </span>
        } @if (opts.showClearButton && (maxControl.value || maxControl.value ===
        0)) {
            <button
                matSuffix
                mat-icon-button
                aria-label="Clear"
                class="field-suffix-clear"
                [class.abs-pos-clear-button]="opts.absPosClearButton"
                (click)="clearMax(opts.applyOnClear)"
            >
                <fa-icon [icon]="['far', 'times-circle']"></fa-icon>
            </button>
        }
    </mat-form-field>

    @if (errMessage) {
        <div class="error-message">
            <fa-icon [icon]="['fas', 'exclamation-triangle']"></fa-icon>
            {{ errMessage }}
        </div>
    }

    <!-- Controls -->
    <div class="filter-actions-container">
        <button
            (click)="onApply()"
            mat-flat-button
            class="is-color-primary apply-filter-btn"
        >
            APPLY
        </button>
    </div>
</div>
